import { render, staticRenderFns } from "./AdminQuestionari.vue?vue&type=template&id=1a3b035f&"
import script from "./AdminQuestionari.vue?vue&type=script&lang=js&"
export * from "./AdminQuestionari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports